export default "__VITE_ASSET__23c3605b__"